import { useEffect } from 'react';

const STYLE_ID = 'receipt-activity-pane-styles';

/*
 * Edge padding for tenant-portal's ~392px activity-center pane (VIS-2032).
 *
 * The pane receipt owns the whole webview, and its content otherwise sits flush against the card
 * border — so add gutters. This does NOT resize type: the pane keeps the receipt's normal scale.
 *
 * Injected globally (and only when the activity-pane marker is set) on purpose: RCL's modal PORTALS the
 * receipt content to document.body, so styles scoped to a receipt wrapper never reach it — these stable
 * class selectors do (`.left-pane`/`.right-pane` on the swipe panes, `.rb-rcpt-summary` on the summary,
 * `.rb-rcpt-cancel` on the cancel-booking confirmation, which is a separate render in the same modal).
 * No @media gate is needed: the marker itself is the pane signal, so phones and the desktop modal (no
 * marker) are untouched. The summary's 130px bottom clearance exists for the swipe modal's fixed action
 * bar, which the pane has no equivalent of (the Done footer is dropped) — trim it so it is not dead space.
 */
const ACTIVITY_PANE_STYLES = `
  .left-pane,
  .right-pane {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .left-pane {
    padding-top: 16px !important;
  }
  .rb-rcpt-summary {
    padding-bottom: 24px !important;
  }
  .rb-rcpt-cancel {
    padding-left: 16px !important;
    padding-right: 16px !important;
    padding-top: 16px !important;
  }
`;

export const useActivityPaneStyles = (isActivityPane: boolean): void => {
  useEffect(() => {
    if (isActivityPane) {
      let styleElement = document.getElementById(STYLE_ID);

      if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = STYLE_ID;
        document.head.appendChild(styleElement);
      }

      styleElement.textContent = ACTIVITY_PANE_STYLES;
    } else {
      const element = document.getElementById(STYLE_ID);
      if (element) {
        element.remove();
      }
    }

    return () => {
      const element = document.getElementById(STYLE_ID);
      if (element) {
        element.remove();
      }
    };
  }, [isActivityPane]);
};
